import { Quote } from 'lucide-react'

import { useWebContent } from '../../hooks/useWebContent'
import { richTextListClassName } from '../../utils/richText'

const testimonialImages = [
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&q=80&fit=crop',
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&q=80&fit=crop',
    'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&q=80&fit=crop',
]

export const TestimonialsSection = () => {
    const { getText } = useWebContent('TESTIMONIALS')

    const testimonials = [
        {
            id: '1',
            quote: getText('quote1'),
            name: getText('name1'),
            role: getText('role1'),
            imageUrl: testimonialImages[0],
        },
        {
            id: '2',
            quote: getText('quote2'),
            name: getText('name2'),
            role: getText('role2'),
            imageUrl: testimonialImages[1],
        },
        {
            id: '3',
            quote: getText('quote3'),
            name: getText('name3'),
            role: getText('role3'),
            imageUrl: testimonialImages[2],
        },
    ]

    return (
        <section id="testimonials" className="bg-white py-24">
            <div className="mx-auto mb-20 w-full max-w-[1280px] px-6 text-center">
                <h2 className="mb-4 text-3xl font-bold text-brand-dark md:text-4xl">
                    {getText('heading')}
                </h2>
                <div
                    dangerouslySetInnerHTML={{ __html: getText('subheading') }}
                    className={`text-lg text-brand-gray ${richTextListClassName}`}
                />
            </div>
            <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-6 md:grid-cols-3">
                {testimonials.map((testimonial) => (
                    <div
                        key={testimonial.id}
                        className="group relative rounded-[2.5rem] border border-slate-100 bg-off-white p-10 shadow-sm transition-all hover:border-primary/20"
                    >
                        <div className="absolute -top-6 left-10 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white shadow-lg">
                            <Quote className="h-6 w-6" />
                        </div>
                        <p className="mb-10 text-lg italic leading-relaxed text-brand-gray">
                            &ldquo;{testimonial.quote}&rdquo;
                        </p>
                        <div className="flex items-center gap-4">
                            <div className="h-14 w-14 rounded-full border-2 border-brand-yellow p-0.5">
                                <div
                                    className="h-full w-full rounded-full bg-cover bg-center"
                                    style={{
                                        backgroundImage: `url("${testimonial.imageUrl}")`,
                                    }}
                                />
                            </div>
                            <div className="text-left">
                                <h5 className="font-bold text-brand-dark">{testimonial.name}</h5>
                                <p className="text-xs font-bold uppercase tracking-widest text-primary">
                                    {testimonial.role}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}
